import { entity, persistence } from 'simpler-state'

export const formSchema = entity({})
export const useFormSchema = (args) => formSchema.use(args)
export const setformSchema = data => {
    formSchema.set(data)
}